import * as clipboard from "clipboard-polyfill";

// A minimal polyfill for `navigator.clipboard.writeText()` that works most of the time in most modern browsers.
// Note that on Edge this may call `resolve()` even if copying failed.
// See https://github.com/lgarron/clipboard-polyfill for a more robust solution.
// License: public domain

export default async function copyText(str: string) {
  try {
    await clipboard.writeText(str);
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
}
